import { Upload } from 'lucide-react';
import { useRef, useState } from 'react';
import { useImportCsv } from '../hooks/useData.js';

export function ImportDropzone() {
  const imp = useImportCsv();
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const handle = (file?: File | null) => {
    if (file) imp.mutate(file);
  };

  return (
    <div>
      <div
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragging(false);
          handle(e.dataTransfer.files?.[0]);
        }}
        className={`flex flex-col items-center gap-2 rounded-lg border border-dashed p-10 text-sm transition ${
          dragging ? 'border-[#3b82f6] bg-[var(--color-panel-2)]' : 'border-[var(--color-border)]'
        }`}
      >
        <Upload size={20} className="text-[var(--color-muted)]" />
        <label htmlFor="csv-input" className="cursor-pointer">
          Drop employees.csv or <span className="underline">click to choose</span>
        </label>
        <a
          href="/sample-employees.csv"
          download
          className="text-xs text-[var(--color-muted)] underline"
        >
          Download sample CSV
        </a>
        <input
          id="csv-input"
          ref={inputRef}
          type="file"
          accept=".csv,text/csv"
          className="hidden"
          onChange={(e) => handle(e.target.files?.[0])}
        />
      </div>
      {imp.isPending && <p className="mt-2 text-sm text-[var(--color-muted)]">Importing…</p>}
      {imp.data && (
        <p className="mt-2 text-sm text-[var(--color-sev-low)]">
          Imported {imp.data.imported}, failed {imp.data.failed}, zones created{' '}
          {imp.data.zonesCreated}.
        </p>
      )}
      {imp.isError && (
        <p className="mt-2 text-sm text-[var(--color-sev-critical)]">Import failed.</p>
      )}
    </div>
  );
}
